
import * as actionTypes from './actionType';

export const selectPath = (pathID) => { return {type: actionTypes.SET_PATH, 'currentPathID': pathID} }
